const eventContent = {
  title: '행사 관리 매뉴얼',
  content: `
  <div class="page-title">[행사 관리]</div>

# [개요]
행사 관리는 기업의 각종 행사 정보를 효율적으로 관리하고 제공하기 위한 도구입니다. 이 문서에서는 **행사의 등록, 수정, 조회 등 전반적인 관리 방법**을 확인할 수 있습니다.

### 주요 기능 요약
| 기능 | 설명 | 권한 |
|------|------------------|------------|
| 행사 조회 | 등록된 행사 목록 확인 및 검색 | 관리자 |
| 행사 등록 | 신규 행사 등록 | 관리자 |
| 행사 수정 | 기존 행사 정보 수정 | 관리자 |

# [조회]
등록된 행사의 목록을 조회하고 관리할 수 있습니다.

### 📋 화면 구성 및 기능
| 영역 | 구성 | 주요 기능 |
|------|------|-----------|
| 검색 영역 | 검색 조건 및 필터 | • 이벤트 유형별 필터링<br>• 제목 기준 검색 |
| 목록 영역 | 행사 목록 테이블 | • 이벤트 유형/제목/장소/사용여부/시작일시 확인<br>• 더블클릭으로 상세 정보 확인 |
| 버튼 영역 | 등록 버튼 | • 신규 행사 등록 |

![행사 목록](/assets/images/guide/event/list.png)

# [등록/수정]
행사를 신규 등록하거나 기존 행사의 상세 정보를 수정할 수 있습니다.

> ⚠️ **주의사항**
> - 시작일시는 필수 입력 항목입니다.
> - 저장 즉시 반영됩니다.

### 📋 화면 구성 및 기능
| 영역 | 입력 항목 | 설명 |
|------|-----------|------|
| 기본 설정 | • 이벤트 유형<br>• 시작일시<br>• 사용 여부 | • 행사 유형 선택<br>• 행사 시작 일시 설정<br>• 행사 사용 여부 설정 |
| 행사 정보 | • 장소<br>• 제목<br>• 내용 | • 행사 장소 입력<br>• 행사 제목 입력<br>• 행사 상세 내용 입력 |

![행사 등록/수정](/assets/images/guide/event/edit.png)
  `,
};

export default eventContent;
